import React from "react";
import { IonButton, IonFooter, IonSpinner } from "@ionic/react";

interface ProgramDetailsFooterProps {
  canSaveDetails: boolean;
  saving: boolean;
  onSave: () => void;
}

const ProgramDetailsFooter: React.FC<ProgramDetailsFooterProps> = ({ canSaveDetails, saving, onSave }) => {
  return (
    <IonFooter className="programDetailsFooter">
      <div className="programDetailsSaveContainer">
        <IonButton
          mode="ios"
          disabled={!canSaveDetails || saving}
          className={`programDetailsSaveButton ${!canSaveDetails && "reflectionsSaveButtonDisabled"}`}
          onClick={onSave}
        >
          {saving ? <IonSpinner className="reflectionSaveSpinner" /> : <div>{"Confirm"}</div>}
        </IonButton>
      </div>
    </IonFooter>
  );
};

export default ProgramDetailsFooter;
